<template>
  <div :theme="site" class="max-w-screen-lg mx-auto overflow-hidden">
    <div class="flex flex-col p-6">
      <div class="lg:text-center">
        <h2
          class="mt-2 text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl sm:leading-10 text-primary"
        >
          Herzlich Willkommen beim Förder.Weg.Weiser
        </h2>
        <p class="mt-4 text-base leading-7 text-gray-500 text-left">
          Viele Bau- und Sanierungsvorhaben oder Maßnahmen zur Energieeffizienz
          und zum Klimaschutz werden öffentlich gefördert. Hier finden Sie
          passende Förderprogramme für Vorhaben in Ihrer Kirchengemeinde oder
          kirchlichen Einrichtung.
        </p>
      </div>
    </div>
    <router-view v-slot="{ Component }">
      <transition :name="transitionClass" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <div class="text-gray-500 rounded-b px-4 py-3 my-5">
      <div class="flex justify-end">
        <div class="flex flex-col">
          <p class="font-bold text-justify">Hinweis zum Datenschutz</p>
          <p class="text-sm text-justify">
            Der Schutz personenbezogener Daten ist uns ein wichtiges Anliegen.
            Daher werden auf dieser Website Nutzungsdaten nur in anonymisierter
            Form zu Optimierungszwecken gesammelt und gespeichert.
          </p>
        </div>
      </div>
    </div>
    <!-- <h3 class="text-right">Hinweis zum Datenschutz</h3>
    <p class="text-right max-w-2xl">
      Der Schutz personenbezogener Daten ist uns ein wichtiges Anliegen. Daher
      werden auf dieser Website Nutzungsdaten nur in anonymisierter Form zu
      Optimierungszwecken gesammelt und gespeichert.
    </p> -->
    <footer class="flex justify-end h-10 text-primary">
      <div class="w-full pl-4 text-xs text-gray-500">
        {{ site }} v{{ version }}
      </div>
      <a
        class="px-2"
        href="https://www.energie-und-kirche.de/datenschutzerklaerung/"
        target="_blank"
        rel="noopener"
      >
        Datenschutz
      </a>
      <router-link
        :to="{ name: 'imprint', params: { site: site } }"
        class="px-2"
      >
        Impressum
      </router-link>
    </footer>
  </div>
</template>

<script>
import { call, get, sync } from 'vuex-pathify'
import SitesData from '@/data/sites.json'

export default {
  props: { site: String, slug: String },
  data() {
    return {
      transitionClass: 'slide-left',
      version: null
    }
  },
  computed: {
    questionsConfig: sync('questions/config'),
    showPrograms: get('programs/show')
  },
  methods: {
    selectProgram: call('programs/load'),
    listQuestions: call('questions/list')
  },
  mounted() {
    if (this.site) {
      const config = SitesData.find((s) => {
        return s.name === this.site
      })
      if (config) this.questionsConfig = config
    }
    if (this.slug) this.selectProgram(this.slug)
    this.listQuestions()
  },
  created() {
    this.version = process.env.VUE_APP_VERSION
  },
  beforeRouteUpdate(to, from, next) {
    if (from.meta.depth > to.meta.depth) {
      this.transitionClass = 'slide-right'
      return next()
    }
    this.transitionClass = 'slide-left'
    next()
  },
  beforeUpdate() {
    if (this.slug) this.selectProgram(this.slug)
  }
}
</script>

<style lang="scss" scoped>
.slide-left-leave-active,
.slide-left-enter-active,
.slide-right-leave-active,
.slide-right-enter-active {
  transition: 0.5s;
}
.slide-left-enter {
  transform: translate(100%, 0);
}

.slide-right-enter {
  transform: translate(-100%, 0);
}

.slide-left-leave-to {
  transform: translate(-100%, 0);
}

.slide-right-leave-to {
  transform: translate(100%, 0);
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
